var _defs, _g, _g2, _g3, _g4, _g5, _path, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.587,
    height: 101,
    viewBox: "0 0 138.587 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4295",
    "data-name": "Rectangle 4295",
    width: 49,
    height: 64,
    transform: "translate(258 859)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 0.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaea"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34085",
    "data-name": "Group 34085",
    transform: "translate(-109.5 -824)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Divit_2D_coin",
    "data-name": "Divit 2D coin",
    transform: "translate(109.5 848.087) rotate(-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M610.078,472.079a10,10,0,1,0,10,10A10,10,0,0,0,610.078,472.079Z",
    transform: "translate(-600.079 -472.079)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26552",
    "data-name": "Group 26552",
    transform: "translate(5.152 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M3.522,12.417h0L0,10.383V7.465H3.334v1.21L7.607,6.208,3.334,3.741V4.952H0V2.033L3.522,0l7.231,4.175V8.241L3.522,12.416Z",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Divit_2D_coin-2",
    "data-name": "Divit 2D coin",
    transform: "translate(232.767 824) rotate(40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445-2",
    "data-name": "Path 37445",
    d: "M610.078,472.079a10,10,0,1,0,10,10A10,10,0,0,0,610.078,472.079Z",
    transform: "translate(-600.079 -472.079)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26552-2",
    "data-name": "Group 26552",
    transform: "translate(5.152 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6-2",
    "data-name": "Subtraction 6",
    d: "M3.522,12.417h0L0,10.383V7.465H3.334v1.21L7.607,6.208,3.334,3.741V4.952H0V2.033L3.522,0l7.231,4.175V8.241L3.522,12.416Z",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Divit_2D_coin-3",
    "data-name": "Divit 2D coin",
    transform: "translate(227.625 908.094) rotate(40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445-3",
    "data-name": "Path 37445",
    d: "M606.079,472.079a6,6,0,1,0,6,6A6,6,0,0,0,606.079,472.079Z",
    transform: "translate(-600.079 -472.079)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26552-3",
    "data-name": "Group 26552",
    transform: "translate(3.091 2.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6-3",
    "data-name": "Subtraction 6",
    d: "M2.113,7.45h0L0,6.23V4.479H2v.726l2.564-1.48L2,2.245v.727H0V1.22L2.113,0,6.452,2.505v2.44L2.113,7.45Z",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32310",
    "data-name": "Group 32310",
    transform: "translate(11)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32309",
    "data-name": "Group 32309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M1667,2617h-24a12,12,0,0,1,24,0Z",
    transform: "translate(-1512 -1781)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4289",
    "data-name": "Rectangle 4289",
    d: "M0,0H56a8,8,0,0,1,8,8V88a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(142 824)",
    fill: "url(#linear-gradient)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32308",
    "data-name": "Group 32308"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(150 840)",
    fill: "#fffaea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_490",
    "data-name": "Line 490",
    x2: 34,
    transform: "translate(164 843)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(150 852)",
    fill: "#fffaea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_491",
    "data-name": "Line 491",
    x2: 34,
    transform: "translate(164 855)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_492",
    "data-name": "Line 492",
    x2: 34,
    transform: "translate(164 863)",
    fill: "none",
    stroke: "#fffaea",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_32243",
    "data-name": "Mask Group 32243",
    transform: "translate(-84 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32307",
    "data-name": "Group 32307",
    transform: "translate(79.785 -10.39)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4292",
    "data-name": "Rectangle 4292",
    d: "M0,0H10a0,0,0,0,1,0,0V19a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(188.67 908.605) rotate(30)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32306",
    "data-name": "Group 32306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    d: "M0,0H10a0,0,0,0,1,0,0V19a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(188.67 908.605) rotate(30)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    transform: "translate(194.215 861) rotate(30)",
    stroke: "#fc3",
    strokeWidth: 4,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "none"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionEmpty);
export default __webpack_public_path__ + "static/media/transaction-empty.cf7cb7676e3b09424d29b733e2147db7.svg";
export { ForwardRef as ReactComponent };